import type { FC } from "react";
import React from "react";

import cn from "classnames";

import { useMouseDownAnimation } from "../../hooks/useMouseDownAnimation";
import { extractProps } from "../../utils/react";

import type { RadioProps } from "./types";

import classes from "./Radio.styl";

const RADIO_DISPLAY_NAME = "Radio";

/**
 * Базовый компонент, с помощью которого пользователь может выбрать только одну из списка доступных опций
 *
 * <a href="https://www.figma.com/design/vTg3KAvmAXA9LigeyiqCWL/%F0%9F%92%A0-Base-Components?m=auto&node-id=2-15886">Спека</a>
 */
export const Radio: FC<RadioProps> = (props) => {
    const {
        id,
        size = "m",
        view = "primary",
        name,
        value,
        checked,
        defaultChecked,
        disabled,
        "data-tsid": tsid,
        onChange,
        "aria-label": ariaLabel,
    } = props;
    const { customColorsStyles } = extractProps(props, ["customColorsStyles"]);
    const { clicked, mousedownHandler } = useMouseDownAnimation();

    const wrapperClasses = cn(
        classes["wrapper"],
        classes[`__view-${view}`],
        {
            [classes["wrapper_size-m"]]: size === "m",
            [classes["wrapper_size-s"]]: size === "s",
            [classes["__clicked"]]: clicked,
            [classes["__disabled"]]: disabled,
        },
        customColorsStyles,
    );

    return (
        <div className={wrapperClasses} onMouseDown={mousedownHandler}>
            <input
                id={id}
                className={classes["radio-input"]}
                type="radio"
                name={name}
                value={value}
                defaultChecked={defaultChecked}
                checked={checked}
                disabled={disabled}
                data-tsid={tsid}
                data-uikit={RADIO_DISPLAY_NAME}
                onChange={onChange}
                aria-label={ariaLabel}
            />
            <div className={classes["main-circle"]}>
                <div className={classes["inner-circle"]}></div>
            </div>
        </div>
    );
};

Radio.displayName = RADIO_DISPLAY_NAME;

export default Radio;
